import { render, staticRenderFns } from "./SplitBox.vue?vue&type=template&id=2eeb730f&scoped=true"
import script from "./SplitBox.vue?vue&type=script&lang=js"
export * from "./SplitBox.vue?vue&type=script&lang=js"
import style0 from "./SplitBox.vue?vue&type=style&index=0&id=2eeb730f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb730f",
  null
  
)

export default component.exports